import * as React from 'react';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Link from '@mui/material/Link';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef ,useState } from 'react';
import Grid from '@mui/material/Grid';
import { useLocation, useSearchParams } from "react-router-dom";
import { store } from '../helpers/store';
import { setPageLoadFinish, setPageLoading } from '../slices/page.slice';
import { fetchInvoices, invoiceItemsSelector, setInvoiceLoading, setInvoiceSearchKeyDeliverylocationumber, setInvoiceSearchKeyFromdate, setInvoiceSearchKeySaletype, setInvoiceSearchKeyTodate, setInvoiceSearchKeyNumber, setInvoiceSearchKey, clearInvoiceFilters, fetchInvoice, clearInvoiceItems, clearSelectedInvoice } from "../slices/invoices.slice";
import DataGrid from 'react-data-grid';
import CircularProgress from '@mui/material/CircularProgress';
import LinearProgress from '@mui/material/LinearProgress';
import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { pink } from '@mui/material/colors';
import SvgIcon from '@mui/material/SvgIcon';
import DehazeIcon from '@mui/icons-material/Dehaze';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import IconButton from '@mui/material/IconButton';
import SaveIcon from '@mui/icons-material/Save';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import TextField from '@mui/material/TextField';
import DatePicker from "react-multi-date-picker"
import { Calendar } from "react-multi-date-picker"
import moment from 'jalali-moment'
import Tooltip from '@mui/material/Tooltip';
import persian from "react-date-object/calendars/persian"
import persian_fa from "react-date-object/locales/persian_fa"
import JalaliUtils from "@date-io/jalaali";
import SearchIcon from '@mui/icons-material/Search';
import FilterAltOffIcon from '@mui/icons-material/FilterAltOff';
import Modal from "@material-ui/core/Modal";
import { useNavigate } from "react-router-dom";
import AppBar from '@mui/material/AppBar';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import ArgonBox from "./dashdata/ArgonBox";
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import textEditor from './dashdata/TextEditor';
import PrintIcon from '@mui/icons-material/Print';
import { addItem, clearSaleDepartment, deleteItem, fetchSaleDepartment, resetSaleDepartmentResultBox, setSaleDepartmentResultBox, submitSaleDepartment, updateItem } from '../slices/saleDepartment.Slice';
import { Checkbox, Dialog, DialogActions, DialogContent, DialogContentText, MenuItem, Select } from '@mui/material';
import { Add } from '@mui/icons-material';
import DialogTitle from '@mui/material/DialogTitle';
import Alert from '@mui/material/Alert';
import CheckIcon from '@mui/icons-material/Check';
import AddBoxIcon from '@mui/icons-material/AddBox';
import CancelIcon from '@mui/icons-material/Cancel';
import BeenhereIcon from '@mui/icons-material/Beenhere';

export const zeroPad = (num, places) => String(num).padStart(places, '0');


const boxSX = {
   backgroundColor : '#FFEB3B', color: '#37474F' ,
  "&:hover": {
    color: '#FFEB3B',
    backgroundColor: '#37474F'
  },
};


export const SaleDepartment = () => {

  const [open, setOpen] = React.useState(false);

  const dispatch = useDispatch();
  //const { user: authUser } = useSelector(x => x.auth);  
  const authUser = JSON.parse(localStorage.getItem('user'))

  const saleDepartment = useSelector(x => x.saleDepartment);
  //const defaultValues = useSelector(x => x.defaultValue);
  const defaultValues = JSON.parse(localStorage.getItem('defaultValue'));

  let navigate = useNavigate();


  const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'left',
    //color: theme.palette.text.secondary,
  }));
  //این اوکیه
  //const [searchParams] = useSearchParams();
  //let entityId = searchParams.get("entityId");


const columns = [
  {
    name: 'ردیف',
    key: 'RowID',
    width: '5%',
  }, 
  {
    key: 'UserName',
    name: 'نام کاربری',
    width: '15%',
    resizable: true,
    sortable: true,
    formatter(props) {
      return <div className=''>
      <TextField InputProps={{ inputProps: { maxLength: 18 } }} size="small" style={{ padding : '0px' , paddingInline : '1px' }} value={props.row.UserName} 
      fullWidth={true}
      disabled={props.row.ID > 0}
        onChange={(e) => handleRowValueChange(e,'UserName', props, props.row.RowID, props.row.ID , props.row.MemberUserId)} />
            </div>;
    }
  },
  {
    key: 'MemberAlias',
    name: 'نام مستعار',
    width: '25%',
    resizable: true,
    sortable: true,
    formatter(props) {
      return <div className=''>
      <TextField InputProps={{ inputProps: { maxLength: 50 } }} size="small" style={{ padding : '0px' , paddingInline : '1px' }} value={props.row.MemberAlias} 
      fullWidth={true}
      //disabled={props.row.IsHead}
        onChange={(e) => handleRowValueChange(e,'MemberAlias', props, props.row.RowID, props.row.ID , props.row.MemberUserId)} />
            </div>;
    }
    
  },
  {
    key: 'MemberDescription',
    name: 'شرح',
    width: '20%',
    resizable: true,
    sortable: true,
    formatter(props) {
      return <div className=''>
      <TextField InputProps={{ inputProps: { maxLength: 50 } }} size="small" style={{ padding : '0px' , paddingInline : '1px' }} value={props.row.MemberDescription} 
      fullWidth={true}
      //disabled={props.row.IsHead}
        onChange={(e) => handleRowValueChange(e,'MemberDescription', props, props.row.RowID, props.row.ID , props.row.MemberUserId)} />
            </div>;
    }
  },
  {
    key: 'AllowedMachines',
    name: 'دستگاه مجاز',
    width: '15%',
    resizable: true,
    sortable: true,
    formatter(props) {
      return <div className=''>
      <TextField InputProps={{ inputProps: { maxLength: 18 } }} size="small" style={{ padding : '0px' , paddingInline : '1px' }} value={props.row.AllowedMachines} 
      fullWidth={true}
      //disabled={props.row.ID > 0}
        onChange={(e) => handleRowValueChange(e,'AllowedMachines', props, props.row.RowID, props.row.ID , props.row.MemberUserId)} />
            </div>;
    }
  },
  {
    key: 'IsActive',
    name: 'فعال؟',
    width: '5%',
    resizable: true,
    sortable: true,
    formatter(props) {
      return <div className=''>
      <Checkbox
        checked={props.row.IsActive}
        disabled={props.row.IsHead}
        onChange={(e) => handleRowValueChange(e,'IsActive', props, props.row.RowID,props.row.ID , props.row.MemberUserId)} 
      />
            </div>;
     }
  },

  {
    key: 'Password',
    name: 'رمز عبور',
    width: '10%',
    resizable: true,
    sortable: true,
    formatter(props) {
      return <div className=''>
      <Checkbox
        checked={props.row.NeedPasswordChange}
        disabled={props.row.IsHead}
        onChange={(e) => handleRowValueChange(e,'NeedPasswordChange', props, props.row.RowID,props.row.ID , props.row.MemberUserId)} 
      />
      <TextField InputProps={{ inputProps: { maxLength: 18 } }} size="small" style={{ padding : '0px' , paddingInline : '1px' }} value={props.row.Password} 
      fullWidth={true} type="password"
      disabled={props.row.IsHead || !props.row.NeedPasswordChange}
        onChange={(e) => handleRowValueChange(e,'Password', props, props.row.RowID,props.row.ID , props.row.MemberUserId)} />
            </div>;
    }
  },
  {
    key: 'RoleName',
    name: 'نقش',
    type: 'number',
    width: '10%',
    resizable: true,
    sortable: true,
    formatter(props) {
      return <div className=''>
         <Select value={props.row.RoleName} disabled={props.row.IsHead} fullWidth={true} 
         onChange={(e) => handleRowValueChange(e,'RoleName', props, props.row.RowID, props.row.ID , props.row.MemberUserId)} > 
          {props.row.IsHead ? <MenuItem value="CustomerPortal">CustomerPortal</MenuItem> : "" }
          <MenuItem value="Optician">Optician</MenuItem>
          <MenuItem value="Personnel">Personnel</MenuItem>
          <MenuItem value="FinancialPersonnel">FinancialPersonnel</MenuItem>
        </Select>
            </div>;
     }
  },
  {
    key: 'IsHead',
    name: 'سرپرست',
    width: '5%',
    resizable: true,
    sortable: true,
    formatter(props) {
      return <div className=''>
      <Checkbox
        checked={props.row.IsHead}
        disabled={true}
        inputProps={{ 'aria-label': 'controlled' }}
      />
            </div>;
     }
  },
  {
    width: '3%',
    name: 'عملیات',
    key: 'Operation',
    formatter(props) {
      if(props.row.ID > 0 ){
        return "";
      }else{
        return <Tooltip title="حذف"><IconButton color="secondary" aria-label="add an alarm" disabled={props.row.ID > 0}
        sx={{ width: 50 }} onClick={(e) => handleOperationOnItem(e,'RemoveItem', props, props.row.RowID)} > 
          <DeleteIcon sx={{ color: '#ff1744' }} />
        </IconButton></Tooltip>;
      }

    },
  }
];


   useEffect(() => {

      dispatch(clearSaleDepartment());
      dispatch(fetchSaleDepartment({authUser}));

   }, []);

   const handleSubmitSaleDepartment = (e) =>{
    setOpen(true);
   }

   const handleRowValueChange = (e , changingItemType, props, rowId, id, memberUserId) => {
    //console.log(changingItemType);
    //console.log(e);
    //console.log(e.target.value);
    //console.log(props);
    //dispatch(updateItem({rowID : props.row.RowID , memberAlias : props.row.MemberAlias , memberDescription : props.row.MemberDescription , isActive : props.row.IsActive , password : props.row.Password , roleName:  props.row.RoleName ,  needPasswordChange : props.row.NeedPasswordChange }));

    switch(changingItemType) {

      case 'IsActive':
        console.log('IsActive');
        console.log(e.target.checked);
        dispatch(updateItem({rowID : props.row.RowID , memberAlias : props.row.MemberAlias , memberDescription : props.row.MemberDescription , isActive : e.target.checked , password : props.row.Password , roleName:  props.row.RoleName ,  needPasswordChange : props.row.NeedPasswordChange  , userName : props.row.UserName, allowedMachines : props.row.AllowedMachines}));
        
          break;   
       case 'NeedPasswordChange':
        console.log('needPasswordChange');
        console.log(e.target.checked);
        dispatch(updateItem({rowID : props.row.RowID , memberAlias : props.row.MemberAlias , memberDescription : props.row.MemberDescription , isActive : props.row.IsActive , password : props.row.Password , roleName:  props.row.RoleName ,  needPasswordChange : e.target.checked  , userName : props.row.UserName, allowedMachines : props.row.AllowedMachines}));
        
          break;   
      case 'RoleName':
            console.log('RoleName');
            console.log(e.target.value);
            dispatch(updateItem({rowID : props.row.RowID , memberAlias : props.row.MemberAlias , memberDescription : props.row.MemberDescription , isActive : props.row.IsActive , password : props.row.Password , roleName:  e.target.value ,  needPasswordChange : props.row.NeedPasswordChange , userName : props.row.UserName , allowedMachines : props.row.AllowedMachines}));
            
              break;     
      case 'Password':
            console.log('Password');
            console.log(e.target.value);
            dispatch(updateItem({rowID : props.row.RowID , memberAlias : props.row.MemberAlias , memberDescription : props.row.MemberDescription , isActive : props.row.IsActive , password : e.target.value , roleName:  props.row.RoleName ,  needPasswordChange : props.row.NeedPasswordChange , userName : props.row.UserName , allowedMachines : props.row.AllowedMachines}));
            
              break;   
      case 'MemberDescription':
            console.log('MemberDescription');
            console.log(e.target.value);
            dispatch(updateItem({rowID : props.row.RowID , memberAlias : props.row.MemberAlias , memberDescription : e.target.value , isActive : props.row.IsActive , password : props.row.Password , roleName:  props.row.RoleName ,  needPasswordChange : props.row.NeedPasswordChange , userName : props.row.UserName , allowedMachines : props.row.AllowedMachines}));
            
              break; 
      case 'MemberAlias':
            console.log('MemberAlias');
            console.log(e.target.value);
            dispatch(updateItem({rowID : props.row.RowID , memberAlias : e.target.value , memberDescription : props.row.MemberDescription , isActive : props.row.IsActive , password : props.row.Password , roleName:  props.row.RoleName ,  needPasswordChange : props.row.NeedPasswordChange  , userName : props.row.UserName, allowedMachines : props.row.AllowedMachines}));
            
              break; 
      case 'UserName':
            console.log('UserName');
            console.log(e.target.value);
            dispatch(updateItem({rowID : props.row.RowID , memberAlias : props.row.MemberAlias , memberDescription : props.row.MemberDescription , isActive : props.row.IsActive , password : props.row.Password , roleName:  props.row.RoleName ,  needPasswordChange : props.row.NeedPasswordChange , userName : e.target.value , allowedMachines : props.row.AllowedMachines }));
            
              break;   
      case 'AllowedMachines':
            console.log('AllowedMachines');
            console.log(e.target.value);
            dispatch(updateItem({rowID : props.row.RowID , memberAlias : props.row.MemberAlias , memberDescription : props.row.MemberDescription , isActive : props.row.IsActive , password : props.row.Password , roleName:  props.row.RoleName ,  needPasswordChange : props.row.NeedPasswordChange , userName : props.row.UserName , allowedMachines : e.target.value }));
            
              break;   
              
      default:
        // code block
    }
  
  }
  
const handleCloseMessageBox = (e) =>{
  dispatch(resetSaleDepartmentResultBox());
}
const handleCloseMessageBoxLoadAgain = (e) =>{
  dispatch(resetSaleDepartmentResultBox());
  dispatch(clearSaleDepartment());
  dispatch(fetchSaleDepartment({authUser}));
}
  function rowKeyGetter(row) {
    return row.RowID;
  }
  const handleHeaderClick = (e) =>{

    console.log("handleHeaderClick");
    dispatch(addItem({ memberAlias :  "" , memberDescription :  "" , isActive : true , password :  "" , roleName:  "" ,  needPasswordChange : "" , userName : "" }));
  }
  
  const handleOperationOnItem = (e , changingItemType, props, rowId) => {
    switch(changingItemType) {

      case 'RemoveItem':
        console.log('RemoveItem');
        dispatch(deleteItem({rowID : rowId }));
        
          break;   
          default:
        // code block
    }
  }



  const handleYes = () => {
    setOpen(false);
    var errors = [];
    console.log(errors);
    if(errors.length === 0){
      dispatch(submitSaleDepartment({ saleDepartment : saleDepartment , authUser}));
    }else{
      var errorMessage = '';
      errors.map((err) => {
        errorMessage += err + '</hr>';
      });
      console.log(errorMessage);
      dispatch(setSaleDepartmentResultBox({message : errorMessage , type : 1}));
    }
  };

  const handleClose = () => {
    setOpen(false);
  };
  const handleNo = () => {
    setOpen(false);
  };



  function EmptyRowsRenderer() {
    return (
    
      <div style={{ textAlign: 'center', gridColumn: '1/-1' }}>
        {saleDepartment.loading ? '' :   ' اطلاعاتی برای نمایش وجود ندارد' }
      </div>
    );
  }
  
  
   let dataSource  = [];
   //let dynamicHeight = 0; 
   if(saleDepartment != undefined && saleDepartment.members !== undefined && saleDepartment.members !== null && saleDepartment.members.length > 0)
   {
       dataSource = saleDepartment.members.map((item, i) => ({...item, rowIndex : i+1}));
       //dynamicHeight = Math.min(invoices.selectedInvoice.items.length * 6 + 10, 75) + 'vh';
   }


   const mdTheme = createTheme({

    typography: {
      fontFamily: [
        "mohammadfont",
        "Tahoma",
        "Verdana"
      ].join(",")
    },
    
    direction: 'rtl',
    components: {
      MuiTooltip: {
        styleOverrides: {
          tooltip: {
            backgroundColor: '#FBC02D',
            color: '#424242'
          },
        },
      },
    }
  });

const onBackClicked = (e) =>{

  navigate('/invoices');

}

  return (
    <>

<ThemeProvider theme={mdTheme}>

  <Box sx={{ flexGrow: 1 }}>
     
     <Grid container>
              <Grid item xs={12}>
                       
             <Accordion expanded={true}>
                <AccordionSummary
                  expandIcon={<ArrowDownwardIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
           
                 <Typography sx={{ width: '60%', flexShrink: 0 }}>
                
                 گروه فروش من       &nbsp; &nbsp;  
                 <Button disabled={saleDepartment.loading} variant="contained" startIcon={<Add />} onClick={(e) => handleHeaderClick(e,'AddMember')}>
                 عضو جدید
</Button>

        
              </Typography>
                     
                       
                </AccordionSummary>
                <AccordionDetails>
                <Grid container spacing={2}>

        <Grid item xs={12} md={5} lg={4}>
          <Item><span style={{ fontWeight : 'bold' }}>کد گروه ‌ : </span> &nbsp;{saleDepartment.code}</Item>
        </Grid>
        <Grid item xs={12} md={5} lg={4}>
          <Item><span style={{ fontWeight : 'bold' }}> عنوان گروه: ‌</span> ‌&nbsp;{saleDepartment.title}</Item>
        </Grid>
      
      </Grid>


<DataGrid 
    renderers={{ noRowsFallback: <EmptyRowsRenderer /> }}
    direction="rtl" 
    columns={columns} 
    rows={dataSource} 
    rowKeyGetter={rowKeyGetter}
    //style={{height : dynamicHeight}}
    />


<Tooltip title="ذخیره اطلاعات">
           <Button disabled={saleDepartment.loading} className='mmgBtnSubmit' color="success" onClick={handleSubmitSaleDepartment} variant="outlined" startIcon={<BeenhereIcon />}>
           ذخیره اطلاعات
           </Button>
           </Tooltip> 
           </AccordionDetails>
          </Accordion>
             </Grid>
     </Grid>

     </Box>
<Dialog
              open={saleDepartment.boxType > 0}
              //onClose={handleCloseMessageBox}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
             >
              <DialogTitle id="alert-dialog-title">
                {"نتیجه عملیات"}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                <Alert severity={saleDepartment.boxType === 1 ? "error" : (saleDepartment.boxType === 2 ? "success" : "info")}>
                <Typography
                    variant="span"
                    color="primary"
                    dangerouslySetInnerHTML={{ __html: saleDepartment.boxMessage }}>
                    
                </Typography>
             
                  </Alert>
                </DialogContentText>
              </DialogContent>
              <DialogActions>
                {saleDepartment.boxType === 2 ?   
                <Button variant="contained" color='success' onClick={handleCloseMessageBoxLoadAgain}>
                       خب
                </Button>
                : 
               <Button variant="contained" color='error' onClick={handleCloseMessageBox}>
                     خب
              </Button>
              }
              </DialogActions>
            </Dialog>
          
    {saleDepartment.loading ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }
    <Dialog
              open={open}
              //onClose={handleClose}
              aria-labelledby="alert-dialog-title"
              aria-describedby="alert-dialog-description"
            >
              <DialogTitle id="alert-dialog-title">
                {"تایید "}
              </DialogTitle>
              <DialogContent>
                <DialogContentText id="alert-dialog-description">
                 آیا از ثبت اطلاعات اطمینان دارید؟
                </DialogContentText>
              </DialogContent>
              <DialogActions>
              <Button variant="contained" color='success' startIcon={<CheckIcon />} onClick={handleYes}>
                بله
              </Button>
              <Button variant="contained" color='error' startIcon={<CancelIcon/>} onClick={handleNo}>
                خیر
              </Button>
            

              </DialogActions>
            </Dialog>

    {saleDepartment.loading ?   <div className="LoadingDiv">در حال تبادل اطلاعات <LinearProgress color="inherit" /></div>: "" }
    </ThemeProvider>
    </>
  );
}

export default SaleDepartment;